<form #currentForm="ngForm" novalidate>
  <div class="form-group">
    <label>Matter User Type</label>
    <select required class="form-control" (change)="getUsers(true)" #matter_user_type_id="ngModel" name="matter_user_type_id" [(ngModel)]="matter_user.matter_user_type_id">
      <option *ngFor="let matter_user_type of form_options.matter_user_types" [value]="matter_user_type.id">{{ matter_user_type.name }}</option>
    </select>
    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(matter_user_type_id)">Matter user type needs to be selected</div>
  </div>
  <div class="form-group">
    <label>Users for Type</label>
    <select required class="form-control" #user_id="ngModel" name="user_id" [(ngModel)]="matter_user.user_id">
      <option *ngFor="let user of users_list" [value]="user.user_id">{{ user.display_name }}</option>
    </select>
    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(user_id)">User needs to be selected</div>
  </div>
  <div class="custom-control custom-checkbox" (click)="matter_user.include_in_all_notifications = !matter_user.include_in_all_notifications">
    <input type="checkbox" class="custom-control-input" [(ngModel)]="matter_user.include_in_all_notifications" [checked]="matter_user.include_in_all_notifications" name="include_in_all_notifications" />
    <label class="custom-control-label">Include in all communications</label>
  </div>
  <div class="form-group text-center">
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-primary" (click)="saveMatterUser(currentForm.form.valid)">Save</button>
    &nbsp;
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-secondary" (click)="cancelForm()">Cancel</button>
  </div>
</form>
